'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Svg = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends__default["default"]({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 40 40",
    role: "img"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "gift-circled_svg__a"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 40)",
    d: "M20 0c11.046 0 20 8.954 20 20s-8.954 20-20 20S0 31.046 0 20 8.954 0 20 0Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#gift-circled_svg__a)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "gift-circled_svg__b"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 40)",
    d: "M-5-5h50v50H-5Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#gift-circled_svg__b)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "gift-circled_svg__c"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 40)",
    d: "M0 0h40v40H0Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#gift-circled_svg__c)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M-5-5h50v50H-5Z",
    fill: "currentColor"
  })), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "gift-circled_svg__d"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 40)",
    d: "M17.06 29.07c-1.89.01-3.73-1.81-2.89-4.07H11a2 2 0 0 1-2-2v-2a1 1 0 0 1 1-1h9v3h2v-3h9a1 1 0 0 1 1 1v2a2 2 0 0 1-2 2h-3.17c1.17 3.27-3.23 5.58-5.26 2.76L20 27l-.57.78c-.63.89-1.5 1.28-2.37 1.29M17 27c.89 0 1.34-1.08.71-1.71-.63-.63-1.71-.18-1.71.71a1 1 0 0 0 1 1m6 0c.89 0 1.34-1.08.71-1.71-.63-.63-1.71-.18-1.71.71a1 1 0 0 0 1 1m-13-8v-8a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v8h-9v-8h-2v8h-9Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#gift-circled_svg__d)"
  }, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "gift-circled_svg__e"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    transform: "matrix(1 0 0 -1 0 40)",
    d: "M0 0h40v40H0Z"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#gift-circled_svg__e)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M4 5.93h32V36H4Z",
    fill: "#fff"
  }))))));
});
var GiftCircled = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement(react.Icon, _extends__default["default"]({
    as: Svg
  }, props, {
    ref: ref
  }));
});
exports.GiftCircled = GiftCircled;